export const contactsData = {
    email: 'miratuujaallataa@gmail.com',
    phone: '+251 961 874 868',
    address: 'Addis Ababa, Ethiopia',
    github: 'https://github.com/mijaleta',
    facebook: 'https://www.facebook.com/miretu.jaleta',
    linkedIn: 'https://www.linkedin.com/in/miretu-jaleta-995b22231/',
    twitter: 'https://twitter.com/mijaletac',
    medium: 'https://medium.com/@miratuujaallataa',
    stackOverflow: 'https://stackoverflow.com/users/18483703/miretu',
    devUsername: "mijaleta"
}